import React from "react";
import { Modal, Button } from "react-bootstrap";
import { Label as LabelForm, Field, Input } from "@zendeskgarden/react-forms";
import { t } from "../../../../../translations/translation.service";
import UserService from "../../../../../services/user.service";
import { AlertService } from "../../../../../services/alert.service";
import { AuthenticationService } from "../../../../../services/auth.service";
import { Datepicker } from "@zendeskgarden/react-datepickers";

interface ExColaboradoresModalProps {
  professionalId: string;
  onSave?: (data: any) => void;
  handleCloseExColaborador: () => void;
  showExColaborador: boolean;
  user?: any;
}

interface ExColaboradoresModalState {
  desligamento: string;
  motivo: string;
  comentario: string;
  recruiter: string;
  data: Date;
  loading: boolean;
  error: string | null;
}

class ExColaboradoresModal extends React.Component<
  ExColaboradoresModalProps,
  ExColaboradoresModalState
> {
  _isMounted = false;
  Tipo = {
    VOL: "Voluntário",
    INVOL: "Involuntário",
  };

  Motivos: Record<"Voluntário" | "Involuntário", string[]> = {
    Voluntário: [
      "Baixa Performance",
      "Contratação pelo Cliente/Outra Consultoria",
      "Encerramento de Contrato/Projeto",
      "Oportunidade de Desenvolvimento/Carreira",
      "Problemas com a Liderança/Perfil/Fit Cultural",
      "Remuneração",
      "Outros",
    ],
    Involuntário: [
      "Alteração do escopo da função",
      "Baixa Performance",
      "Corte de custos no cliente/Interno",
      "Encerramento de Contrato/Projeto",
      "Problemas comportamentais / Perfil",
    ],
  };

  constructor(props: ExColaboradoresModalProps) {
    super(props);

    const ex = props.user?.ex_eluminer || {};
    this.state = {
      desligamento: ex.shutdown || "",
      motivo: ex.voluntaryTermination || ex.involuntaryTermination || "",
      comentario: ex.commentShutdown || "",
      recruiter : ex.recruiter || "",
      data: ex.selectDate ? new Date(ex.selectDate) : new Date(),
      loading: false,
      error: null,
    };
  }

  componentDidUpdate(prevProps: ExColaboradoresModalProps) {
    if (
      (this.props.user && this.props.user !== prevProps.user) ||
      (this.props.showExColaborador && !prevProps.showExColaborador)
    ) {
      const ex = this.props.user?.ex_eluminer || {};
      this.setState({
        desligamento: ex.shutdown || "",
        motivo: ex.voluntaryTermination || ex.involuntaryTermination || "",
        comentario: ex.commentShutdown || "",
        data: ex.selectDate ? new Date(ex.selectDate) : new Date(),
      });
    }
  }

  formatDate(date: Date) {
    return new Intl.DateTimeFormat("pt-BR", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  }

  parseDateBr(input: string) {
    if (input.length === 10) {
      const [d, m, y] = input.split("/");
      return new Date(`${m}/${d}/${y}`);
    }
    return new Date();
  }

  handleTipo = (e: any) => {
    this.setState({
      desligamento: e.target.value,
      motivo: "",
    });
  };

  handleMotivo = (e: any) => {
    this.setState({ motivo: e.target.value });
  };

  handleComentario = (e: any) => {
    const value = e.target.value;
    const sanitized = value.replaceAll(/[^a-zA-Z0-9À-ÿ .,;:!?'"()@#%&*_/\-\\|^+]/g,"");
    this.setState({ comentario: sanitized });
  };

  componentDidMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }


  handleSave = async () => {
    const { professionalId, handleCloseExColaborador, onSave } = this.props;
    const { desligamento, motivo, comentario, data } = this.state;
    if (!desligamento) {
      AlertService.warn(t("Informe o tipo de desligamento."));
      return;
    }
    if (!motivo) {
      AlertService.warn(t("Informe o motivo do desligamento."));
      return;
    }
    if (!comentario) {
      AlertService.warn(t("Descreva o complemento do desligamento."));
      return;
    }
    if (!data) {
      AlertService.warn(t("Informe a data do desligamento."));
      return;
    }
    if (this._isMounted) {
      this.setState({ loading: true, error: null });
    }

    try {
      const user = AuthenticationService.getUser();

      const payload = {
        ex_eluminer: {
          status: true,
          shutdown: desligamento,
          commentShutdown: comentario,
          selectDate: data,
          shutdownDate: new Date(),
          recruiter: { _id: user._id, displayName: user.displayName },
          voluntaryTermination: desligamento === this.Tipo.VOL ? motivo : undefined,
          involuntaryTermination: desligamento === this.Tipo.INVOL ? motivo : undefined,
        }
      };
      const response = await UserService.updateCollaboratorExEluminer(professionalId, payload);

      AlertService.success(t("Informação sobre ex-eluminer salva com sucesso!"));

      if (onSave) 
        onSave(response.data);

      handleCloseExColaborador();

    } catch (err) {
      console.log(err);
      if (this._isMounted) {
        this.setState({ error: t("Erro ao salvar motivo.") });
      }
      AlertService.error(t("Erro ao salvar Informação sobre desligamento."));
    } finally {
      if (this._isMounted) {
        this.setState({ loading: false });
      }
    }
  };

  render() {
    const { showExColaborador, handleCloseExColaborador } = this.props;
    const { desligamento, motivo, comentario, data, loading } = this.state;

    const motivos =
      desligamento && (desligamento === this.Tipo.VOL || desligamento === this.Tipo.INVOL)
        ? this.Motivos[desligamento as "Voluntário" | "Involuntário"]
        : [];

    return (
      <Modal
        show={showExColaborador}
        onHide={handleCloseExColaborador}
        centered
        size="lg"
      >
        <Modal.Header closeButton>
          <h1 className="header-modal-edit m-0">
            {t("Informações De Ex-Eluminer")}
          </h1>
        </Modal.Header>
        <Modal.Body>
          <Field>
            <LabelForm>{t("Tipo de desligamento")}</LabelForm>
            <select
              className="form-control"
              value={desligamento}
              onChange={this.handleTipo}
            >
              <option value="">{t("Selecione...")}</option>
              <option value={this.Tipo.VOL}>{this.Tipo.VOL}</option>
              <option value={this.Tipo.INVOL}>{this.Tipo.INVOL}</option>
            </select>
          </Field>
          <Field style={{ marginTop: 16 }}>
            <LabelForm>{t("Motivo do desligamento")}</LabelForm>
            <select
              className="form-control"
              value={motivo}
              disabled={!desligamento}
              onChange={this.handleMotivo}
            >
              <option value="">{t("Selecione...")}</option>
              {motivos.map((m: string) => (
                <option key={m} value={m}>
                  {m}
                </option>
              ))}
            </select>
          </Field>
          <Field style={{ marginTop: 16 }}>
            <LabelForm>{t("Data do desligamento")}</LabelForm>
            <Datepicker
              value={data}
              onChange={(d) => this.setState({ data: d ?? new Date() })}
              formatDate={(d) => this.formatDate(d)}
              customParseDate={this.parseDateBr}
              maxValue={new Date()}
              locale="pt-BR"
            >
              <Input className="mt-2" />
            </Datepicker>
          </Field>
          <Field style={{ marginTop: 16 }}>
            <LabelForm>{t("Complemento")}</LabelForm>
            <textarea
              className="form-control"
              rows={4}
              maxLength={150}
              value={comentario}
              onChange={this.handleComentario}
              placeholder={t("Descreva o motivo do desligamento...")}
            />
            <div className="texto-comentario">
              {comentario.length}/150
            </div>
          </Field>
        </Modal.Body>
        <Modal.Footer>
          <Button
            className="modal-footer-save-button"
            onClick={this.handleSave}
          >
            {loading ? t("Salvando...") : t("Salvar")}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default ExColaboradoresModal;
